import React, { Component } from "react";
import { connect } from "react-redux";
import RealMap from "../maps/realMap";
import RealTimeTable from "./realTimeTable";
import "../../styles/realTime/realTime.scss";
import Layout from "../../Layout/layout";
import { Helmet } from "react-helmet";
import axios from "axios";
import signalRHelper from "../../utils/signalRHelper";
import { apiHost } from "../../api/apiClient";
import NoRecords from "./noRecords";
import { setRealtimeGroup, setRealtimeGroupId, setRealtimeGroupName, setLoadingPage } from "../../reducers/actions";
import { Button } from "react-bootstrap";
import $ from "jquery";
import _ from "lodash";

class RealTime extends Component {
  constructor(props) {
    super(props);

    this.state = {
      realTimeData: [],
      connectionCheck: "connection string",
      mapChange: "",
      singleTruckZoom: "",
      groupName: "",
      listgroup: "",
      dataLoading: false,
      isFullScreen: false,
    };

    this.currentList = [];
    this.initialMount = true; // Add a flag to track initial mount

    this.throttleListUpdate = _.throttle(function () {
      this.setState({ realTimeData: this.currentList });
    }, 15000);
  }

  async componentDidMount() {
    if (localStorage.getItem("realTimeGroupId")) {
      this.props.setRealtimeGroupIdAction(localStorage.getItem("realTimeGroupId"));
      this.props.setRealtimeGroupNameAction(localStorage.getItem("realTimeGroupName"));
    }

    this.setGroup(this.props.realTimeGroupId);
    this.setGroupList();
    this.handleSignalR();
    
    // Add fullscreen change event listeners
    document.addEventListener("fullscreenchange", this.handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", this.handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", this.handleFullscreenChange);
    document.addEventListener("MSFullscreenChange", this.handleFullscreenChange);
  }

  componentDidUpdate(prevProps) {
    if (this.props.realTimeGroupId != prevProps.realTimeGroupId) {
      this.setGroup(this.props.realTimeGroupId);
    }
  }

  setSpecificGroup = async (value) => {
    let a = this.props.realTimeGroupName.split("-");
    if (a[1]) {
      this.setState({ groupName: `${a[1]}(${a[0]})` });
    }
    this.props.setLoadingPageAction(true);
    if (value || value === 0) {
      if (value !== 0) {
        signalRHelper.setGroupFilter(value);
      } else {
        signalRHelper.resetGroupFilter();
      }
      try {
        this.setState({ dataLoading: true });

        const response = await axios.get(`${apiHost}/api/Assets/AssetsByCustomerIdWithIMEI?GroupId=${value}`, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });

        if (response.status == "200") {
          if (this.props.loading) {
            this.throttleListUpdate.cancel();
            this.currentList = response.data;
            this.setState({ realTimeData: response.data });
          }
        }

        this.setState({ dataLoading: false });
        this.props.setLoadingPageAction(false);
      } catch (e) {
        this.setState({ dataLoading: false });
        this.props.setLoadingPageAction(false);
        console.log(e.response.status);
        if (e.response.status == "401") {
          this.props.history.push("/login");
        }
        console.log(`😱 Axios request failed: ${e}`);
      }
    }
  };

  setAllGroup = async () => {
    // debugger;
    this.setState({ groupName: "" });
    this.props.setLoadingPageAction(true);

    signalRHelper.resetGroupFilter();

    try {
      const response = await axios.get(`${apiHost}/api/Assets/AssetsByCustomerIdWithIMEI`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      if (response.status == "200") {
        if (this.props.loading) {
          this.throttleListUpdate.cancel();
          this.currentList = response.data;
          this.setState({ realTimeData: response.data });
        }
      }
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e && e.response && e.response.status == "401") {
        this.props.history.push("/login");
      }
      this.props.setLoadingPageAction(false);
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  setGroup = async (groupId) => {
    this.props.setLoadingPageAction(true);
    if (groupId == "all") {
      this.setAllGroup();
    } else {
      this.setSpecificGroup(groupId);
    }
  };

  handleFullScreen = () => {
    const elem = $("#realMapContainer")[0];
    
    if (!this.state.isFullScreen) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  };
  
  handleFullscreenChange = () => {
    const isFullScreen = 
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement;
      
    this.setState({ isFullScreen: !!isFullScreen });
  };

  setGroupList = async () => {
    try {
      const response = await axios.get(`${apiHost}/api/Assets/GroupsByCurrentUser`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      if (response.status == "200") {
        this.setState({ listgroup: response.data[0] });

        if (response.data && response.data.length > 0) {
          this.props.setRealtimeGroupAction(response.data);

          if (!localStorage.getItem("realTimeGroupId")) {
            this.props.setRealtimeGroupIdAction(response.data[0].groupId);
            this.props.setRealtimeGroupNameAction(response.data[0].customername + " - " + response.data[0].groupName);
            localStorage.setItem("realTimeGroupId", response.data[0].groupId);
            localStorage.setItem("realTimeGroupName", response.data[0].customername + " - " + response.data[0].groupName);
          }
        }
      }
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      }
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  async handleSignalR() {
    this.connection = await signalRHelper.getConnection();
    this.addTransferChartDataListener();
  }

  componentWillUnmount() {
    this.releaseSignalR();
    
    // Remove fullscreen change event listeners
    document.removeEventListener("fullscreenchange", this.handleFullscreenChange);
    document.removeEventListener("webkitfullscreenchange", this.handleFullscreenChange);
    document.removeEventListener("mozfullscreenchange", this.handleFullscreenChange);
    document.removeEventListener("MSFullscreenChange", this.handleFullscreenChange);
  }

  releaseSignalR() {
    if (!this.connection) {
      return;
    }
    // Release signalR handlers
    signalRHelper.unsubscribe("RealTimeMap");
    signalRHelper.resetAssetFilter();
    signalRHelper.resetGroupFilter();

    this.connection.off("RealTimeMap");
    this.connection = null;
  }

  addTransferChartDataListener = () => {
    signalRHelper.subscribe("RealTimeMap");

    this.connection.on("RealTimeMap", (data) => {
      this.data = data;
      this.createNewList(data);
      this.updateMap(JSON.stringify(data));
    });
  };

  updateMap = (data) => {
    this.setState({ mapChange: data });
  };

  createNewList = (data) => {
    var isIdentified = this.currentList.some((item) => item.assetId === data.assetId);

    if (!isIdentified) {
      this.currentList.push(data);
    } else {
      this.currentList.forEach((list, index) => {
        if (list.assetId == data.assetId) {
          this.currentList[index] = data;
        }
      });
    }

    this.throttleListUpdate();
  };

  handleTruckSelection = (data) => {
    this.setState({ singleTruckZoom: data });
  };

  render() {
    let defaultGroup =
      this.state.listgroup && this.state.listgroup.groupName ? this.state.listgroup.groupName + "-" + this.state.listgroup.customername : "";
    const { realTimeData, mapChange, singleTruckZoom, dataLoading } = this.state;
    return (
      <React.Fragment>
        <Layout customGroups={true}>
          <Helmet>
            <title>RealTime</title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper">
              <div>
                <div className="real-firstRow">
                  <h1 className="real-heading">
                    Real Time <span className="real-span">v1.0.3</span>
                    <span className="real-group">{this.state.groupName ? this.state.groupName : defaultGroup}</span>
                  </h1>
                  <Button onClick={this.handleFullScreen}>
                    <i className={this.state.isFullScreen ? "fa fa-compress" : "fa fa-expand"}></i>
                  </Button>
                </div>
                {this.state.realTimeData.length > 0 && !dataLoading ? (
                  <div>
                    <RealMap mapChange={mapChange} singleTruckZoom={singleTruckZoom} realTimeData={realTimeData} isFullScreen={this.state.isFullScreen} />
                    <h4>
                      <i className="fa fa-envelope-o"></i> Last event or message
                    </h4>
                    <RealTimeTable realTimeData={realTimeData} onTruckSelection={this.handleTruckSelection} />
                  </div>
                ) : (
                  !this.state.realTimeData.length && !this.state.dataLoading && <NoRecords />
                )}
              </div>
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  realTimeGroupId: state.realTimeGroupId,
  realTimeGroupName: state.realTimeGroupName,
  loading: state.loading,
});
const mapDispatchToProps = {
  setRealtimeGroupAction: setRealtimeGroup,
  setRealtimeGroupIdAction: setRealtimeGroupId,
  setRealtimeGroupNameAction: setRealtimeGroupName,
  setLoadingPageAction: setLoadingPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(RealTime);
